// OverlayWrapper.js
import React, { useEffect } from 'react';
import Loader from './loader';
import './OverlayWrapper.css';

const OverlayWrapper = ({ isLoading, children }) => {
  useEffect(() => {
    // Prevent scrolling when isLoading is true
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      // Cleanup: Allow scrolling when the component unmounts
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  return (
    <div className={`overlay-wrapper ${isLoading ? 'loading' : ''}`}>
      {isLoading && (
        <div className="overlay">
          <div className="loader-container">
            <Loader />
          </div>
        </div>
      )}
      <div className="content">{children}</div>
    </div>
  );
};

export default OverlayWrapper;
